import React from "react"
import { graphql } from "gatsby"

import ContentContainer from "../components/contentcontainer"
import ImageHeader from "../components/imageheader"
import Layout from "../components/layout"
import Seo from "../components/seo"
import HtmlContent from "../components/html-content"

import * as styles from "./blog-post.module.css"

//import heroStyles from '../components/hero.module.css'

const BlogPostTemplate = ({ data, pageContext }) => {
  const post = data.contentfulBlogPost
  //const siteTitle = get(this.props, 'data.site.siteMetadata.title')

  return (
    <Layout styleBodyForContent={true}>
      <ImageHeader />
      <ContentContainer>
        <h1>{post.title}</h1>
        <div className={styles.meta}>
          <time className={styles.date}>{post.publishDate}</time>
          <div className={styles.byline}>
            by {getAuthorsByLine(post.authors)}
          </div>
        </div>
        <HtmlContent html={post.body.childMarkdownRemark.html} />
      </ContentContainer>
    </Layout>
  )
}

const getAuthorsByLine = authors => {
  const authorNames = authors.map(author => author.name)

  // per Array to Comma separated string and for last tag use the 'and' instead of comma
  // https://stackoverflow.com/a/16251861
  return [authorNames.slice(0, -1).join(", "), authorNames.slice(-1)[0]].join(
    authorNames.length < 2 ? "" : " and ",
  )
  //return "Murray Cox", "Murray, Alice and John" or "Murray Cox and Tom Slee"
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    contentfulBlogPost(slug: { eq: $slug }) {
      title
      publishDate(formatString: "MMMM DD, YYYY")
      body {
        childMarkdownRemark {
          html
        }
      }
      authors {
        name
        title
        company
      }
    }
  }
`

export function Head({ data }) {
  const post = data.contentfulBlogPost

  return <Seo title={post.title} />
}
